import { Button, Stack } from "@mui/material";
import { useState } from "react";
import FlexBox from "../layouts/flexbox";
import { MemberAvatarGroup } from "./member-avatar-group";
import { MemberListTable } from "./member-list-table";
import { useStyles } from "./styles";
import { ExpandableMemberAvatarGroupProps } from "./types";
import { MEMBER_VISIBLE_MAX } from "./utils";

function ExpandableMemberAvatarGroup({
  members = [],
  showAddButton = false,
  onAddClick,
  addButtonTitle,
}: ExpandableMemberAvatarGroupProps) {
  const classes = useStyles();
  const [showAll, setShowAll] = useState(false);
  const hasMore = members.length > MEMBER_VISIBLE_MAX;

  return (
    <Stack width="100%">
      <FlexBox alignItems="center" gap={0.75} flexWrap="wrap">
        <MemberAvatarGroup
          members={members}
          max={MEMBER_VISIBLE_MAX}
          showAddButton={showAddButton}
          onAddClick={onAddClick}
          addButtonTitle={addButtonTitle}
        />
        {hasMore && (
          <Button
            variant="text"
            size="small"
            classes={{ root: classes.showAllButton }}
            onClick={() => setShowAll((prev) => !prev)}
          >
            {showAll ? "Show less" : "Show all"}
          </Button>
        )}
      </FlexBox>
      {showAll && <MemberListTable members={members} />}
    </Stack>
  );
}

export { ExpandableMemberAvatarGroup };
